import * as React from "react";
import { UitkCard, UitkCardContent, UitkCardTextSegment, UitkCardMedia } from "uitk-react-cards";
import { UitkImage, UitkFigure, UitkFigureAspectRatioType } from "uitk-react-images";
import { UitkButton, UitkPrimaryButton } from "uitk-react-button";
import { UitkIcon } from "uitk-react-icons";
import { Viewport, ViewSmall, ViewLarge } from "bernie-view";
import { useLocalization } from "@shared-ui/localization-context";
import { MapMarkerCardProps, MapMarkerCardViewProps } from "../typings";
import { MarkerIcon } from "../markers/MapMarkers";

import { FlexClickTracker } from "src/components/utility/analytics/FlexClickTracker/FlexClickTracker";
import { Action, sendImmediateTrackEvent } from "components/utility/analytics/FlexAnalyticsUtils";
import { UitkHeading, UitkText } from "uitk-react-text";
import { UitkLayoutFlex } from "uitk-react-layout-flex";

const ButtonTracked = FlexClickTracker(UitkPrimaryButton);

export const MAP_CARD_ID = "dx-map-card";
export const MAP_CARD_IMAGE_ID = "dx-map-card-image";
const moduleName = "MapMarkerCard";

export const MapMarkerCard = (props: MapMarkerCardProps) => {
  return (
    <Viewport>
      <ViewSmall>
        <MapMarkerCardView showCard={props.showCard} onClose={props.onClose} content={props.content} isMobile={true} />
      </ViewSmall>
      <ViewLarge>
        <MapMarkerCardView showCard={props.showCard} onClose={props.onClose} content={props.content} isMobile={false} />
      </ViewLarge>
    </Viewport>
  );
};

const MapMarkerCardView = (props: MapMarkerCardViewProps) => {
  const { formatText } = useLocalization();
  const cardClasses = props.isMobile ? "map-card" : "map-card map-card--desktop";

  const closeMapMarkerCard = () => {
    const trackingInfo = {
      moduleName,
      action: Action.CLICK,
      rfrr: "mapMarker.close"
    };

    sendImmediateTrackEvent(trackingInfo, props.analytics);
    props.onClose();
  };

  return (
    <div id={MAP_CARD_ID} className={props.showCard ? `${cardClasses} map-card--reveal` : cardClasses}>
      <UitkCard>
        <UitkCardTextSegment>
          <UitkLayoutFlex justifyContent="space-between" alignItems="center">
            <UitkHeading size={500} level={2}>
              {props.content.title}
            </UitkHeading>
            <UitkButton title={formatText("destinationDiscoveryMap.button.card.close")} onClick={closeMapMarkerCard}>
              <UitkIcon name="close" />
            </UitkButton>
          </UitkLayoutFlex>
        </UitkCardTextSegment>
        {Boolean(props.content.photoUrl) && (
          <UitkCardMedia>
            <UitkFigure ratio={UitkFigureAspectRatioType.R16_9}>
              <UitkImage
                placeholderImage={true}
                alt={props.content.attribution?.attributionAltText || props.content.photoAlt}
                src={props.content.photoUrl}
              />
              {props.content.attribution?.attributionText}
            </UitkFigure>
          </UitkCardMedia>
        )}
        <UitkCardContent>
          {Boolean(props.content.price) && (
            <UitkCardTextSegment className="uitk-card-separator-bottom uitk-type-right">
              {props.content.type === MarkerIcon.HOTEL && (
                <UitkText size={600}>{formatText("destinationDiscoveryMap.hotel.price", props.content.price)}</UitkText>
              )}
              {props.content.type === MarkerIcon.ACTIVITY && (
                <UitkText size={600}>
                  {formatText("destinationDiscoveryMap.activity.price", props.content.price)}
                </UitkText>
              )}
            </UitkCardTextSegment>
          )}
          <UitkCardTextSegment className="uitk-flex">
            {props.content.description}
            <ButtonTracked
              moduleName="findHotel"
              className="map-card__button--margin"
              rfrr="map.marker"
              linkName="RFRR Action Event"
              text={props.content.buttonLabel}
              icon={props.content.buttonIcon}
              isFullWidth={true}
              href={props.content.link}
            />
          </UitkCardTextSegment>
        </UitkCardContent>
      </UitkCard>
    </div>
  );
};

export default MapMarkerCard;
